var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * CZNA-1421 — the "Sigla" facet of the review queue: one checkbox per `040 $a` value of the
 * items the queue shows the user, with its count, plus "bez sigly" for items without one.
 *
 * <p>The values and counts come from the server under the queue's own visibility, so the
 * facet can offer nothing the user is not already shown. A remembered sigla that is no
 * longer in the queue stays listed (count 0) — otherwise it would filter the list to nothing
 * with no checkbox left to clear it.
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Checkbox, MessageBanner } from '@folio/stripes/components';
import { isSiglaSelectionEmpty } from '../utils/reviewQueueSiglaSelection';
var ReviewQueueSiglaFilter = function (_a) {
    var _b, _c, _d;
    var facet = _a.facet, isError = _a.isError, selection = _a.selection, onChange = _a.onChange;
    var intl = useIntl();
    var offered = (_b = facet === null || facet === void 0 ? void 0 : facet.siglas) !== null && _b !== void 0 ? _b : [];
    var offeredValues = new Set(offered.map(function (option) { return option.sigla; }));
    var options = __spreadArray(__spreadArray([], offered, true), selection.siglas
        .filter(function (sigla) { return !offeredValues.has(sigla); })
        .map(function (sigla) { return ({ sigla: sigla, itemCount: 0 }); }), true);
    var toggle = function (sigla, checked) { return onChange(__assign(__assign({}, selection), { siglas: checked
            ? __spreadArray(__spreadArray([], selection.siglas, true), [sigla], false) : selection.siglas.filter(function (value) { return value !== sigla; }) })); };
    return (React.createElement("div", { "data-testid": "review-queue-sigla-filter" },
        isError ? (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.review.queue.sigla.error" }))) : null,
        React.createElement("div", { style: { maxHeight: '20rem', overflowY: 'auto' } },
            options.map(function (option) { return (React.createElement(Checkbox, { key: option.sigla, label: intl.formatMessage({ id: 'ui-czna-authorities.review.queue.sigla.option' }, { sigla: option.sigla, count: option.itemCount }), checked: selection.siglas.includes(option.sigla), onChange: function (event) {
                    return toggle(option.sigla, event.target.checked);
                }, "data-test-sigla-option": option.sigla })); }),
            ((_c = facet === null || facet === void 0 ? void 0 : facet.withoutSiglaCount) !== null && _c !== void 0 ? _c : 0) > 0 || selection.withoutSigla ? (React.createElement(Checkbox, { label: intl.formatMessage({ id: 'ui-czna-authorities.review.queue.sigla.without' }, { count: (_d = facet === null || facet === void 0 ? void 0 : facet.withoutSiglaCount) !== null && _d !== void 0 ? _d : 0 }), checked: selection.withoutSigla, onChange: function (event) {
                    return onChange(__assign(__assign({}, selection), { withoutSigla: event.target.checked }));
                }, "data-test-sigla-without": true })) : null),
        !isSiglaSelectionEmpty(selection) ? (React.createElement(Button, { buttonStyle: "link", marginBottom0: true, onClick: function () { return onChange({ siglas: [], withoutSigla: false }); }, "data-test-sigla-clear": true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.review.queue.sigla.clear" }))) : null));
};
export default ReviewQueueSiglaFilter;
